module.exports = __webpack_public_path__ + "static/media/experientialmarketing.6d09478c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/experientialmarketing.jpg
// module id = 386
// module chunks = 0